import { render, staticRenderFns } from "./CustomerComplaintSalesDetail.vue?vue&type=template&id=b025a8f4&"
import script from "./CustomerComplaintSalesDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintSalesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports